import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { ActivatedRoute, Router } from '@angular/router';
import { CollectionService } from '../collection.service';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { Util } from '../../../utils/util';
import { Sacado } from '../models/sacado.model';

@Component({
	selector: 'app-collection-details',
	templateUrl: './details.component.html',
	styleUrls: ['./details.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CollectionDetailsComponent implements OnInit {

	public confirmList: Array<ListItem> = [];
	public message = '';
	public messageType = '';
	public id: any;
	public type = 'visualizar';
	public sacado: Sacado = new Sacado();

	constructor(
		private route: ActivatedRoute,
		private collectionService: CollectionService,
		private router: Router,
	) {}

	ngOnInit(): void {
		this.route.params.subscribe(params => {
			this.id = params.id;
			this.type = params.type;
			this.getById();

			if (this.type === 'create') {
				this.message = 'Sacado cadastrado com sucesso!';
				this.messageType = 'success';
			} else if (this.type === 'edit') {
				this.message = 'Sacado editado com sucesso!';
				this.messageType = 'success';
			}
		});
	}

	getById() {
		this.collectionService.getById(this.id).subscribe(data => {
			if (data.Existe) {
				this.sacado = Util.keysToCamel(data.Retorno) as Sacado;
				this.buildConfirmList();
			}
		}, error => {
			console.error(error);
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});

	}

	buildConfirmList() {
		this.confirmList = [];
		this.confirmList.push(new ListItem(this.sacado.cPFCNPJ.length > 11 ? 'Razão Social' : 'Nome', this.sacado.nome));
		this.confirmList.push(new ListItem('CPF/CNPJ', this.sacado.cPFCNPJ));
		this.confirmList.push(new ListItem('E-mail', this.sacado.email));
		this.confirmList.push(new ListItem('Cep', this.sacado.cEP));
		this.confirmList.push(new ListItem('Endereço', this.sacado.endereco));
		this.confirmList.push(new ListItem('Bairro', this.sacado.bairro));
		this.confirmList.push(new ListItem('Número', this.sacado.numero));
		this.confirmList.push(new ListItem('Complemento', this.sacado.complemento));
		this.confirmList.push(new ListItem('Cidade/Estado', this.sacado.cidade + '/' + this.sacado.uF));
	}

	emit() {
		this.collectionService.setSacadoToEmit(this.sacado);
		this.router.navigate(['cobranca/valor-data/novo']);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/collection/details/details.component.ts